<template>
  <div>
    <div class="row mb-5">
      <span class="display-4 col-12">
        {{ `${taxGroup.name}` }} - {{ $t("COMMON.LOGS") }}
      </span>
    </div>

    <log-list-table :filterSubject="taxGroup" />
  </div>
</template>
<script>
import LogListTable from "@/views/Pages/DefaultModule/LogManagement/partials/LogListTable.vue";

export default {
  name: "tax-group-view-logs",

  components: { LogListTable },

  props: ["taxGroup"],

  mixins: [],

  data() {
    return {};
  },

  computed: {},

  methods: {},

  mounted() {},

  watch: {
    user(user) {},
  },
};
</script>
